import { render, staticRenderFns } from "./ClientCards.vue?vue&type=template&id=517d607b&scoped=true&"
import script from "./ClientCards.vue?vue&type=script&lang=js&"
export * from "./ClientCards.vue?vue&type=script&lang=js&"
import style0 from "./ClientCards.vue?vue&type=style&index=0&id=517d607b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d607b",
  null
  
)

export default component.exports